// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"581":"d6e1d6a608a7e9500fc8","917":"9a7638c8d89faa8fdf0d","925":"90d0a321a410105c1a0f"}[chunkId] + ".bundle.js";
};